import { Map as MapComponent } from 'views/components/base/map/map/map';
import { getZones } from 'services/zones/zonesService';
import { selectZones, setZones, addCardIndexInZones, setZonesTypeMap } from 'redux/slices/zones';
import { setNotificationMessage, setNotificationType } from 'redux/slices/notification';
import { setPopupData, setType } from 'redux/slices/popup';
import { useAppSelector } from 'redux/hooks';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useZoneRefs } from 'views/components/base/map/map/editZonesHooks';
import { Card, Map, Zone, ZonesTypeMap } from 'constants/index';
import { selectEditLot, setEditLot } from 'redux/slices/lotEdition';
import { EditCardZonesControls } from './controls/editCardZonesControls';
import { getMapById } from '../../../../services/maps/mapService';
import { updateCards } from '../../../../services/card/cardService';

// NOTE: get edited lot from store and also cards

export function EditCardZones() {
  const dispatch = useDispatch();
  const [map, setMap] = useState<Map>();

  // Keep the ids of the factuel and solution lots to display them on the map if needed
  const [solutionAndFactualLotsIds, setSolutionAndFactualLotsIds] = useState<{
    solution: string;
    factual: string;
  }>();

  // Get the cards lots and zones from the redux store
  const zones = useAppSelector(selectZones);
  const lot = useAppSelector(selectEditLot);

  // Get the refs of the zones on the map
  const { zoneRefs } = useZoneRefs(zones);

  useEffect(() => {
    if (zones.length === 0) {
      if (lot.mapId) {
        getMapById(lot.mapId).then(async (map: Map) => {
          const zoneData = await getZones();
          setSolutionAndFactualLotsIds(zoneData.solutionAndFactualLots);

          setMap(map);
          dispatch(setZones(map.zones));
          dispatch(setZonesTypeMap(ZonesTypeMap.edition));
        });
      }
    } else if (zones.length > 0) {
      // populate cardsInZones
      populateCardsInZones();
    }
  }, [lot.mapId, zones]);

  const populateCardsInZones = () => {
    if (lot) {
      // get zones which contains lots
      const cardsInZones = lot.cards.filter((card) => !!card.zoneId);

      cardsInZones.forEach((cardInZone) => {
        const index = lot.cards.map((card) => card._id).indexOf(cardInZone._id);
        dispatch(addCardIndexInZones([cardInZone._id, index]));
      });
    }
  };

  const handleCardDragStop = (zoneId: string, card: Card): boolean => {
    const zone = zones.find((z: Zone) => z._id === zoneId);

    if (zone && lot._id) {
      const newCards = lot.cards.map((c: Card) => {
        if (c._id === card._id) {
          return { ...c, zoneId: zoneId };
        }
        return c;
      });
      dispatch(setEditLot({ ...lot, cards: newCards }));
      dispatch(setNotificationType('validation'));
      dispatch(setNotificationMessage('cardPlacedLot'));
      return true;
    } else {
      dispatch(setNotificationType('error'));
      dispatch(setNotificationMessage('cardNotPlacedInLot'));
      return false;
    }
  };

  // Save zones to the database, accessible from the map controls only if all cards were set on the map
  const saveZones = async () => {
    if (lot._id) {
      const saved = await updateCards(lot._id, lot.cards);
      if (saved) {
        // dispatch the popup action to open the popup for publication
        dispatch(setPopupData({ lot, isCreate: true }));
        dispatch(setType('publishLot'));
      }
    }
  };

  if (!map) return null;

  return (
    <MapComponent
      isEditLot
      map={map}
      lotId={lot._id}
      cards={lot.cards}
      zoneRefs={zoneRefs}
      isAdminEdit={false}
      solutionAndFactualLotsIds={solutionAndFactualLotsIds}
      mapControls={
        <EditCardZonesControls cards={lot.cards} saveZones={saveZones} onCardDragStop={handleCardDragStop} />
      }
    />
  );
}
